<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Prospect</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="mb-2 flex w-fit flex-col gap-1 md:flex-row">
    <button
      class="shorter-btn add-btn"
      [routerLink]="[
        '../prospect',
        '00000000-0000-0000-0000-000000000000'
      ]"
    >
      <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add
    </button>
    <app-search-input
      (dataOutput)="onSearch($event, 'IcNo')"
      [isTable]="true"
      [placeHolder]="'Search ICNO...'"
    ></app-search-input>
    <app-search-input
      (dataOutput)="onSearch($event, 'Name')"
      [isTable]="true"
      [placeHolder]="'Search name...'"
    ></app-search-input>
  </div>
  <div class="content-container">
    <app-data-table
      (edit)="editEntry($event)"
      (remove)="removeEntry($event)"
      [sorting]="true"
      [tableHeaders]="tableHeaders"
      [tableEntries]="filteredUsers"
      [pageSize]="10"
    ></app-data-table>
  </div>
</section>
